import React, { useState } from 'react';
import { Input, Collapse, Empty } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import '../assets/styles/Faq.css';

const { Panel } = Collapse;

// Datos de ejemplo para las preguntas frecuentes
const faqData = [
  {
    category: "Productos",
    questions: [
      { q: "¿Qué tipos de cañerías certificadas ofrecen?", a: "Ofrecemos una amplia gama de cañerías certificadas, incluyendo PVC, CPVC, y tuberías de cobre." },
      { q: "¿Cómo puedo verificar la certificación de sus productos?", a: "Todos nuestros productos vienen con un certificado de autenticidad que puede ser verificado en nuestra página web." },
    ]
  },
  {
    category: "Pedidos y Envíos",
    questions: [
      { q: "¿Cuál es el tiempo de entrega promedio?", a: "El tiempo de entrega promedio es de 3 a 5 días hábiles, dependiendo de su ubicación." },
      { q: "¿Realizan envíos internacionales?", a: "Sí, realizamos envíos internacionales. Por favor, contacte a nuestro equipo de ventas para más detalles." },
    ]
  },
  {
    category: "Garantía y Devoluciones",
    questions: [
      { q: "¿Cuál es su política de devoluciones?", a: "Aceptamos devoluciones dentro de los 30 días posteriores a la compra, siempre que el producto esté en su estado original." },
      { q: "¿Ofrecen garantía en sus productos?", a: "Sí, todos nuestros productos tienen una garantía de 1 año contra defectos de fabricación." },
    ]
  },
];

const Faq = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredFaq = faqData.map(category => ({
    ...category,
    questions: category.questions.filter(q =>
      q.q.toLowerCase().includes(searchTerm.toLowerCase()) ||
      q.a.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.questions.length > 0);

  return (
    <div className="faq-page">
      <div className="faq-container">
        <h1>Preguntas Frecuentes</h1>
        <Input
          size="large"
          placeholder="¿Con qué podemos ayudarte?"
          prefix={<SearchOutlined />}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <div className="faq-content">
          {filteredFaq.length > 0 ? (
            <div className="faq-categories">
              {filteredFaq.map((category, index) => (
                <div key={index} className="faq-category">
                  <h2>{category.category}</h2>
                  <Collapse bordered={false} expandIconPosition="right">
                    {category.questions.map((q, qIndex) => (
                      <Panel header={q.q} key={qIndex}>
                        <p>{q.a}</p>
                      </Panel>
                    ))}
                  </Collapse>
                </div>
              ))}
            </div>
          ) : (
            <Empty
              description="No se encontraron resultados. Por favor, intenta con otra búsqueda."
              className="no-results"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Faq;

